import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetDataTableV2 } from './useGetDataTableV2'
import { DataTableV2Content } from './DataTableV2Content'

export const DataTableV2Component = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data, refetch, isRefetching } = useGetDataTableV2(id, tileFilterSelections)

  return (
    <DataTableV2Content
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
      reloadHandler={refetch}
      isRefetching={isRefetching}
    />
  )
}

export function DataTableV2ComponentLoading() {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="animate-pulse text-muted-foreground">Loading table...</div>
    </div>
  )
}
